var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation-menu-for-pc'),_c('navigation-menu-for-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }